<template>
  <div class="animated fadeIn">
    <b-row :key="iteration">
      <b-col md="2" class="tabtext font-weight-bold">
        <span style="vertical-align: middle;">{{ current_zip.Zip }}</span>
      </b-col>
      <b-col
        :md="calculatedColumnWidth"
        v-for="filter in current_zip.Filters"
        :key="filter.ZipFilterID"
      >
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-model.lazy="filter.Quantity"
              type="text"
              autocomplete="off"
              v-mask="'#####'"
              @change.native="saveField(filter)"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="1" class="tabtext font-weight-bold">
        <span style="vertical-align: middle;">{{ SubTotal }}</span>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CurrentZipRow",
  components: {},
  props: {
    current_zip_object: { type: Object },
    seminar_object: { type: Object },
    row_width: Number,
    myIteration: Number
  },
  data() {
    return {
      current_zip: this.current_zip_object,
      current_seminar: this.seminar_object,
      calculatedColumnWidth: this.row_width,
      iteration: this.myIteration
    };
  },
  methods: {
    saveField: function(event) {
      //console.log(event);
      //   var _operation = {
      //     SeminarID: this.current_seminar.SeminarID,
      //     FilterID: this.current_filter.FilterID,
      //     FieldToSet: event.target.id,
      //     ValueToSet: event.target.value
      //   };

      this.$store.dispatch("seminar/SaveZipFilter", event).then();
    }
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    SubTotal() {
      var _total = 0;
      this.current_zip.Filters.forEach(filter => {
        _total += parseInt(filter.Quantity);
      });
      return _total;
    }
  },
  created() {
    //console.log(this.current_zip.Filters);
  },
  watch: {
    // "current_seminar.Filters.length": function() {
    // }
  },
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
